export default {
    "getFeaturedCategories": "e132e838814ecb07fa6a0669b917dbb7a7d3e4a662c563c7969dfdcfdf28f71d"
};
